import Vue from 'vue'
import Vuex from 'vuex';
import * as faceapi from 'face-api.js';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    leadData: {},
    message: 'Cogneetiv Workspace AI',
    labeledFaceDescriptors: null,
    firstTimeMessage: null,
    allUsers: [],
    salesAssociates: [],
    seniorSalesAssociates: [],
    tasks: [] // Add tasks to state
  },
  mutations: {
    SET_SALES_ASSOCIATES(state, payload) {
      state.salesAssociates = payload;
    },
    SET_SENIOR_SALES_ASSOCIATES(state, payload) {
      state.seniorSalesAssociates = payload;
    },
    SET_EMAIL(state, payload) {
      state.email = payload;
    },
    setAllUsers(state, users) {
      state.allUsers = users;
    },
    // Synchronous way to store state in vuex
    updateMessage(state, payload) {
      state.message = payload.message
    },
    SET_LEAD_DATA(state, payload) {
      state.leadData = payload;
    },
    // Add task-related mutations
    setTasks(state, tasks) {
      state.tasks = tasks;
    },
    addTask(state, task) {
      state.tasks.push(task);
    },
    updateTask(state, updatedTask) {
      const index = state.tasks.findIndex(task => task.id === updatedTask.id);
      if (index !== -1) {
        state.tasks.splice(index, 1, updatedTask);
      }
    },
    deleteTask(state, taskId) {
      state.tasks = state.tasks.filter(task => task.id !== taskId);
    },
    async initilizeFaceAPI() {
      // console.log(faceapi.nets.tinyFaceDetector.loadFromUri('/models'))
      await faceapi.nets.tinyFaceDetector.loadFromUri('https://cogneetive-face-detection.s3.amazonaws.com/faceapi-model/models');
      await faceapi.nets.faceLandmark68Net.loadFromUri('https://cogneetive-face-detection.s3.amazonaws.com/faceapi-model/models');
      await faceapi.nets.faceRecognitionNet.loadFromUri('https://cogneetive-face-detection.s3.amazonaws.com/faceapi-model/models');
      await faceapi.nets.ssdMobilenetv1.loadFromUri('https://cogneetive-face-detection.s3.amazonaws.com/faceapi-model/models');
      console.log('Initializing Modals video')
    }
  },
  actions: {
    // Asynchronous always goes to actions
    fetchTasks({ commit }) {
      fetch(`${process.env.VUE_APP_NODE_SERVER}task-form/all`)
        .then(response => response.json())
        .then(data => {
          commit('setTasks', data.result);
        });
    },
    addTask({ commit }, task) {
      fetch(`${process.env.VUE_APP_NODE_SERVER}task-form/create`, {
        method: 'POST',
        body: JSON.stringify(task),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(response => response.json())
        .then(data => {
          commit('addTask', data.result);
        });
    },
    updateTask({ commit }, task) {
      fetch(`${process.env.VUE_APP_NODE_SERVER}task-form/update`, {
        method: 'POST',
        body: JSON.stringify(task),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(response => response.json())
        .then(data => {
          commit('updateTask', data.result);
        });
    },
    deleteTask({ commit }, taskId) {
      fetch(`${process.env.VUE_APP_NODE_SERVER}task-form/delete`, {
        method: 'POST',
        body: JSON.stringify({ id: taskId }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(response => response.json())
        .then(() => {
          commit('deleteTask', taskId);
        });
    }
  },
  getters: {
    // Grab information and display anywhere in our app
    userTasks: (state) => (user) => {
      return state.tasks.filter(task => task.taskOwner === user.username);
    }
  },
  modules: {
  }
})
